export default __webpack_public_path__ + "static/media/background4.f1c80e37.png";